import { render, staticRenderFns } from "./heroOne.vue?vue&type=template&id=d700022a&"
import script from "./heroOne.vue?vue&type=script&lang=js&"
export * from "./heroOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports